import { http } from '@/lib/http'
import { listOrEmpty } from '@/lib/utils'
import type { NotificationListResponse } from '@/types/models'

export interface NotificationListParams {
  page?: number
  size?: number
  /** `false` = unread only (the server filters; the mobile app never filters a loaded page locally). */
  read?: boolean
}

export const notificationsApi = {
  list: (params: NotificationListParams): Promise<NotificationListResponse> =>
    http.get<NotificationListResponse>('/v2/notifications', { params }).then((r) => ({ ...r, notifications: listOrEmpty(r.notifications) })),
  unreadCount: () => http.get<{ unread: number }>('/v2/notifications/unread-count').then((r) => r?.unread ?? 0),
  markRead: (id: string) => http.patch<null>(`/v2/notifications/${id}/read`, {}),
  markAllRead: () => http.patch<null>('/v2/notifications/read-all', {}),
  /** Landlord only. Fire-and-forget; rate-limited to one call per hour per IP (429 on the second). */
  dueReminders: () => http.post<null>('/notifications/due-reminders', {}),
}
